import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "circle-container" }
const _hoisted_2 = {
  key: 0,
  class: "circle circle-true"
}
const _hoisted_3 = {
  key: 1,
  class: "circle circle-false"
}
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxExport = _resolveComponent("DxExport")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxTexts = _resolveComponent("DxTexts")!
  const _component_DxGrouping = _resolveComponent("DxGrouping")!
  const _component_DxGroupPanel = _resolveComponent("DxGroupPanel")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxStateStoring = _resolveComponent("DxStateStoring")!
  const _component_DxColumnChooser = _resolveComponent("DxColumnChooser")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxItem = _resolveComponent("DxItem")!
  const _component_DxToolbar = _resolveComponent("DxToolbar")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_openBlock(), _createBlock(_component_DxDataGrid, {
    ref: _ctx.liniiDataGrid,
    "allow-column-reordering": true,
    "data-source": _ctx.dsLiniiDocumente,
    "allow-column-resizing": true,
    "column-auto-width": false,
    "column-min-width": 50,
    "column-resizing-mode": 'nextColumn',
    "show-borders": true,
    "sync-lookup-filter-values": false,
    "filter-sync-enabled": true,
    onRowDblClick: _ctx.onRowDblClick
  }, {
    circleTemplate: _withCtx(({ data }) => [
      _createElementVNode("div", _hoisted_1, [
        (data.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, "✔"))
          : (_openBlock(), _createElementBlock("div", _hoisted_3))
      ])
    ]),
    documentLinkTemplate: _withCtx(({ data }) => [
      _createElementVNode("a", {
        class: "numar-link",
        onClick: _withModifiers(($event: any) => (_ctx.openDocument(data.data)), ["prevent"])
      }, _toDisplayString(data.value), 9, _hoisted_4)
    ]),
    filterToggleTemplate: _withCtx(() => [
      _createVNode(_component_DxButton, {
        icon: "filter",
        text: "Filtre",
        "styling-mode": "contained",
        class: "filter-toggle-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle-filters')))
      })
    ]),
    periodToggleTemplate: _withCtx(() => [
      _createVNode(_component_DxButton, {
        icon: "event",
        text: "Perioadă",
        "styling-mode": "contained",
        class: "filter-toggle-btn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle-filters', 'date')))
      })
    ]),
    documentToggleTemplate: _withCtx(() => [
      _createVNode(_component_DxButton, {
        icon: "doc",
        text: "Document",
        "styling-mode": "contained",
        class: "filter-toggle-btn",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('toggle-filters', 'document')))
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_DxExport, {
        enabled: true,
        formats: ['pdf', 'xlsx'],
        "load-panel": { enabled: true, showIndicator: true, text: 'Loading...' }
      }),
      _createVNode(_component_DxFilterRow, { visible: true }),
      _createVNode(_component_DxGrouping, { "context-menu-enabled": true }, {
        default: _withCtx(() => [
          _createVNode(_component_DxTexts, {
            "group-continued-message": "Continuat de pe pagina anterioara",
            "group-continues-message": "Continuat pe pagina urmatoare"
          })
        ]),
        _: 1
      }),
      _createVNode(_component_DxGroupPanel, {
        visible: true,
        emptyPanelText: "Trage aici o coloana pentru a grupa datele"
      }),
      _createVNode(_component_DxLoadPanel, {
        enabled: true,
        text: "Loading...",
        "indicator-src": 'reload6.gif'
      }),
      _createVNode(_component_DxSorting, { mode: "multiple" }),
      _createVNode(_component_DxStateStoring, {
        enabled: true,
        filterValue: false,
        "storage-key": "dsLiniiDocumente"
      }),
      _createVNode(_component_DxColumnChooser, {
        enabled: true,
        title: "Selector coloane",
        allowSearch: true,
        sortOrder: "asc"
      }),
      _createVNode(_component_DxSearchPanel, {
        visible: true,
        width: 240,
        placeholder: "Cauta ..."
      }),
      _createVNode(_component_DxPaging, {
        "page-size": 10,
        "page-index": 0
      }),
      _createVNode(_component_DxToolbar, null, {
        default: _withCtx(() => [
          _createVNode(_component_DxItem, {
            location: "before",
            template: "filterToggleTemplate"
          }),
          _createVNode(_component_DxItem, {
            location: "before",
            template: "periodToggleTemplate"
          }),
          _createVNode(_component_DxItem, {
            location: "before",
            template: "documentToggleTemplate"
          }),
          _createVNode(_component_DxItem, { name: "searchPanel" }),
          _createVNode(_component_DxItem, { name: "exportButton" }),
          _createVNode(_component_DxItem, { name: "columnChooserButton" })
        ]),
        _: 1
      }),
      _createVNode(_component_DxColumn, {
        "data-field": "Numar",
        caption: "Numar document",
        "cell-template": "documentLinkTemplate"
      }),
      _createVNode(_component_DxColumn, {
        "data-field": "Categorie",
        caption: "Categorie document"
      }),
      _createVNode(_component_DxColumn, {
        "data-field": "Tip",
        caption: "Tip document"
      }),
      _createVNode(_component_DxColumn, {
        "data-field": "Data",
        caption: "Data contabilă",
        "data-type": "date",
        format: "yyyy-MM-dd"
      }),
      _createVNode(_component_DxColumn, {
        "data-field": "Partener",
        caption: "Partener"
      }),
      _createVNode(_component_DxColumn, {
        "data-field": "Produs",
        caption: "Produs"
      }),
      _createVNode(_component_DxColumn, {
        "data-field": "Unitate",
        caption: "Unitate"
      }),
      _createVNode(_component_DxColumn, {
        "data-field": "Cantitate",
        caption: "Cantitate",
        "data-type": "number",
        format: "#0.00"
      }),
      _createVNode(_component_DxColumn, {
        "data-field": "PretUnitar",
        caption: "Pret unitar",
        "data-type": "number",
        format: "#0.0000",
        allowSearch: false
      }),
      _createVNode(_component_DxColumn, {
        "data-field": "Total",
        caption: "Total",
        "data-type": "number",
        format: "#0.00",
        allowSearch: false
      }),
      _createVNode(_component_DxColumn, {
        "data-field": "Valuta",
        caption: "Valuta"
      }),
      _createVNode(_component_DxColumn, { caption: "Context document" }, {
        default: _withCtx(() => [
          _createVNode(_component_DxColumn, {
            "data-field": "ContractNumar",
            caption: "Numar contract",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Proiect",
            caption: "Proiect",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Comanda",
            caption: "Comanda",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Zona",
            caption: "Zona",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "AgentNume",
            caption: "Agent",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "DataDoc",
            caption: "Data document",
            visible: false,
            "data-type": "date",
            format: "yyyy-MM-dd"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Scadenta",
            caption: "Data scadenta",
            visible: false,
            "data-type": "date",
            format: "yyyy-MM-dd"
          })
        ]),
        _: 1
      }),
      _createVNode(_component_DxColumn, { caption: "Rezumat financiar" }, {
        default: _withCtx(() => [
          _createVNode(_component_DxColumn, {
            "data-field": "Valoare",
            caption: "Valoare",
            visible: false,
            "data-type": "number",
            format: "#0.00",
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "ValoareTva",
            caption: "Valoare TVA",
            visible: false,
            "data-type": "number",
            format: "#0.00",
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Tva",
            caption: "TVA %",
            visible: false,
            "data-type": "number",
            format: "#0.00",
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Tvaunitar",
            caption: "TVA unitar",
            visible: false,
            "data-type": "number",
            format: "#0.0000",
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "PretTotal",
            caption: "Pret total",
            visible: false,
            "data-type": "number",
            format: "#0.00",
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Pret",
            caption: "Pret",
            visible: false,
            "data-type": "number",
            format: "#0.00",
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "ValoarePret",
            caption: "Valoare pret",
            visible: false,
            "data-type": "number",
            format: "#0.00",
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "AdaosUnitar",
            caption: "Adaos unitar",
            visible: false,
            "data-type": "number",
            format: "#0.00",
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "ValoareAdaos",
            caption: "Valoare adaos",
            visible: false,
            "data-type": "number",
            format: "#0.00",
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Adaos",
            caption: "Adaos",
            visible: false,
            "data-type": "number",
            format: "#0.00",
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "PretCuAdaos",
            caption: "Pret cu adaos",
            visible: false,
            "data-type": "number",
            format: "#0.00",
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "ValoareCuAdaos",
            caption: "Valoare cu adaos",
            visible: false,
            "data-type": "number",
            format: "#0.00",
            allowSearch: false
          })
        ]),
        _: 1
      }),
      _createVNode(_component_DxColumn, { caption: "Loturi & stoc" }, {
        default: _withCtx(() => [
          _createVNode(_component_DxColumn, {
            "data-field": "Lot",
            caption: "Lot",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "CodLotIntern",
            caption: "Cod lot intern",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "CodLotFurnizor",
            caption: "Cod lot furnizor",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "DataExp",
            caption: "Data expirare",
            visible: false,
            "data-type": "date",
            format: "yyyy-MM-dd"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "LotData",
            caption: "Data lot",
            visible: false,
            "data-type": "date",
            format: "yyyy-MM-dd"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "LotFixat",
            caption: "Lot fixat?",
            visible: false,
            "cell-template": "circleTemplate",
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Intrari",
            caption: "Intrari",
            visible: false,
            "data-type": "number",
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Iesiri",
            caption: "Iesiri",
            visible: false,
            "data-type": "number",
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "LocDepozitare",
            caption: "Loc depozitare",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "GarantieLuni",
            caption: "Garantie luni",
            visible: false,
            "data-type": "number",
            allowSearch: false
          })
        ]),
        _: 1
      }),
      _createVNode(_component_DxColumn, { caption: "Audit" }, {
        default: _withCtx(() => [
          _createVNode(_component_DxColumn, {
            "data-field": "DataCreare",
            caption: "Data creare",
            visible: false,
            "data-type": "date",
            format: "yyyy-MM-dd"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "DataModificare",
            caption: "Data modificare",
            visible: false,
            "data-type": "date",
            format: "yyyy-MM-dd"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "UserCreare",
            caption: "User creare",
            visible: false,
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "UserModificare",
            caption: "User modificare",
            visible: false,
            allowSearch: false
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["data-source", "onRowDblClick"]))
}